import { Injectable } from '@angular/core';
import { ApiService, HttpResponse, HttpStatusEnum } from '@core/api';
import { TranslateService } from '@ngx-translate/core';
import { ToasterHelper } from '@shared/helpers';
import { MessageService } from 'primeng/api';

@Injectable({
    providedIn: 'root',
})
export class SharedOrderApi {
    private readonly resourceUrl = 'orders';

    constructor(
        private apiService: ApiService,
        private messageService: MessageService,
        private translateService: TranslateService
    ) {}

    deleteDraft(orderId: number) {
        return new Promise<HttpResponse<void>>(resolve => {
            this.apiService.delete(`${this.resourceUrl}/delete-draft?id=${orderId}`).subscribe({
                next: () => {
                    resolve({ data: null, status: HttpStatusEnum.SUCCESS });
                    this.messageService.add(
                        ToasterHelper.success(this.translateService.instant('order.list.table.orderDeleted'))
                    );
                },
                error: () => {
                    resolve({ data: null, status: HttpStatusEnum.ERROR });
                },
            });
        });
    }
}
